import React, { useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  Badge,
  CircularProgress,
  Fab,
  styled,
  Tooltip,
} from '@material-ui/core'
import { getPendingWebCompaniesCount, updateWebCompanies } from '@/api/admin'
import { toast } from 'react-toastify'

import { UserPlus } from 'phosphor-react'

const StyledFab = styled(Fab)(({ theme }) => ({
  backgroundColor: theme.palette.info.main,
  color: theme.palette.info.contrastText,

  '&:hover': {
    backgroundColor: theme.palette.info.dark,
  },

  '&.Mui-disabled': {
    backgroundColor: theme.palette.info.dark,
  },
}))

export function UpdateWebCompaniesButton({ onSuccess }) {
  const [isLoading, setIsLoading] = useState(false)

  const [webCompaniesCount, setPendingWebCompaniesCount] = useState(0)

  const handleGetWebCompaniesCount = useCallback(async () => {
    const count = await getPendingWebCompaniesCount()

    setPendingWebCompaniesCount(count)
  }, [])

  async function handleUpdateWebCompanies() {
    setIsLoading(true)

    const completed = await updateWebCompanies()

    if (completed) {
      toast.success('Cadastro atualizado')

      const newCount = await getPendingWebCompaniesCount()

      if (newCount > 0) {
        toast.info('Verifique o cadastro das companhias não adicionadas.')
      }

      onSuccess()
    }

    setIsLoading(false)
  }

  useEffect(() => {
    handleGetWebCompaniesCount()
  }, [handleGetWebCompaniesCount])

  if (webCompaniesCount === 0) return null

  return (
    <Tooltip title="Atualizar cadastro">
      <StyledFab
        disabled={isLoading}
        onClick={handleUpdateWebCompanies}
        color="secondary"
      >
        <Badge color="error" badgeContent={webCompaniesCount} max={99}>
          {isLoading ? (
            <CircularProgress color="secondary" />
          ) : (
            <UserPlus size={28} />
          )}
        </Badge>
      </StyledFab>
    </Tooltip>
  )
}

UpdateWebCompaniesButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
}
